export default "__VITE_ASSET__N9G004NG__"